// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Represents common errors that can occur during an RPC call.
 * The integer values are used for serialization.
 */
export enum RpcErrorCode
{
  Unknown = 100,
  Custom = 101,
  Timeout = 102,
  Canceled = 103,
  Unauthorized = 104
}